import React, { useEffect, useState } from "react";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from 'react-i18next';

export default function BankTransactionWrongLink() {
    const { t } = useTranslation();
    const [sec, setSec] = useState(5);
    useEffect(() => {
        if (sec > 1) {
            setTimeout(() => {
                setSec(sec - 1);
            }, 1000);
        } else {
            window.open('https://fdpco.ir/contact/', "_self");
        }
    }, [sec]);
    return (
        <>
            <div className="text-center shadow-lg py-4 px-4 mx-3" style={{'borderRadius':'10px', 'backgroundColor':'#db7100'}}>
                <strong style={{'fontSize':'18px', 'color':'#fff'}}>
                    <Translator id={'wrong_address'} noSpan />
                </strong>
            </div>
            <span className="pt-4">
                {`${t('supported_site')} (${sec})`}
            </span>
        </>
    );
}
